import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 9999,
  }}>
    <Spinner animation="border" variant="success" />
  </div>
);

export default Loader;
